





import { useEffect, useState } from "react";
import {
  getExpenseCategoriesApi,
  addOfficeExpenseApi,
} from "../../app/api";
import { toast } from "react-toastify";
import {
  PlusCircle,
  IndianRupee,
  Tag,
  ShieldCheck,
  Calendar,
  Activity,
  User,
  StickyNote,
  UploadCloud,
  CheckCircle2,
  X,
  CreditCard
} from "lucide-react";
 
/* SUCCESS MODAL (Premium Glass) */
function SuccessModal({ show, message, onClose }) {
  if (!show) return null;
 
  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-md" onClick={onClose} />
      <div className="
        relative w-full max-w-sm
        bg-gradient-to-br from-[#1e174a] to-[#0f0c29]
        rounded-[40px] p-10 text-center
        border border-white/20 shadow-2xl animate-scaleIn
      ">
        <div className="flex justify-center mb-8">
          <div className="w-24 h-24 rounded-[32px] bg-green-500/20 flex items-center justify-center shadow-inner">
            <CheckCircle2 className="w-12 h-12 text-green-400" />
          </div>
        </div>
        <h3 className="text-3xl font-black mb-3 text-white">Successfully Submit!</h3>
        <p className="text-white/50 text-base mb-10 leading-relaxed font-medium">
          The office expense has been successfully Submitted.
        </p>
        <button
          onClick={onClose}
          className="
            w-full py-4 rounded-2xl font-bold bg-white text-black
            hover:bg-blue-300 transition shadow-xl
          "
        >
          Done
        </button>
      </div>
    </div>
  );
}
 
export default function AddExpense() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
 
  const [form, setForm] = useState({
    amount: "",
    expense_category_id: "",
    is_hr_account: 1,
    purchase_date: new Date().toISOString().split("T")[0],
    purpose: "",
    vendor_info: "",
    remark: "",
    bill: null,
  });
 
  const [errors, setErrors] = useState({});
 
  const loadCategories = async () => {
    const res = await getExpenseCategoriesApi();
    if (res.success) setCategories(res.data || []);
    else toast.error("Failed to load categories");
  };
 
  useEffect(() => {
    loadCategories();
  }, []);
 
  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm({ ...form, [name]: value });
    if (errors[name]) setErrors(prev => ({ ...prev, [name]: "" }));
  };
 
  const handleFile = (e) => {
    const file = e.target.files[0];
    if (file) setForm({ ...form, bill: file });
  };
 
  const submitExpense = async () => {
    const newErrors = {};
    if (!form.expense_category_id) newErrors.expense_category_id = "Required";
    if (!form.amount) newErrors.amount = "Required";
    if (!form.purchase_date) newErrors.purchase_date = "Required";
 
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return toast.error("Please provide all mandatory details");
    }
 
    const fd = new FormData();
    Object.keys(form).forEach(key => fd.append(key, form[key]));
 
    setLoading(true);
    const res = await addOfficeExpenseApi(fd);
    setLoading(false);
 
    if (res.success) {
      setShowSuccessModal(true);
      setForm({
        amount: "",
        expense_category_id: "",
        is_hr_account: 1,
        purchase_date: new Date().toISOString().split("T")[0],
        purpose: "",
        vendor_info: "",
        remark: "",
        bill: null,
      });
    } else {
      toast.error(res.message || "Failed to log expense");
    }
  };
 
  return (
    <div className="max-w-8xl mx-auto md:mt-20 mb-20">
    <div className="
      relative overflow-hidden
      rounded-[20px] p-8 md:p-12
      bg-gradient-to-br from-[#1e174a] to-[#0f0c29]/95
      backdrop-blur-2xl text-white
      border border-white/10
      shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]
    ">
        {/* Decorative Elements */}
        <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-600/10 blur-[100px] pointer-events-none" />
        <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-600/10 blur-[100px] pointer-events-none" />
 
        <div className="relative z-10">
          <div className="flex items-center gap-4 mb-8">
            <div className="p-3.5 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 shadow-lg shadow-blue-500/20">
              <PlusCircle className="w-8 h-8 text-white" />
            </div>
            <div>
              <h1 className="text-3xl font-semibold text-white">Add Expense</h1>
              <p className="text-white/60 text-sm">Record a new office expenditure into the ledger</p>
            </div>
          </div>
 
                 {/* FORM GRID */}
                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
 
 <div className="flex flex-col gap-1">
   <input
     name="amount"
     placeholder="Amount"
     value={form.amount}
     onChange={handleChange}
     className={`bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border ${errors.amount ? 'border-red-500' : 'border-white/10'} text-white w-full`}
   />
   {errors.amount && <span className="text-red-500 text-xs">{errors.amount}</span>}
 </div>

 <div className="flex flex-col gap-1">
   <select
     name="expense_category_id"
     value={form.expense_category_id}
     onChange={handleChange}
     className={`bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border ${errors.expense_category_id ? 'border-red-500' : 'border-white/10'} text-white w-full`}
   >
     <option value="" className="bg-[#24155a] text-white">Select Category</option>
     {categories.map((c) => (
       <option key={c.id} value={c.id} className="bg-[#24155a] text-white">
         {c.name}
       </option>
     ))}
   </select>
   {errors.expense_category_id && <span className="text-red-500 text-xs">{errors.expense_category_id}</span>}
 </div>

 {/* <div className="flex flex-col gap-1">
   <select
     name="is_hr_account"
     value={form.is_hr_account}
     onChange={handleChange}
     className="bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white w-full"
   >
     <option value="1">HR Account</option>
     <option value="0">Office Account</option>
   </select>
 </div> */}

<div className="flex flex-col gap-1">
  <select
    name="is_hr_account"
    value={form.is_hr_account}
    onChange={handleChange}
    className="bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white  w-full"
  >
    <option value="1" className="text-black bg-white">
      HR Account
    </option>
    <option value="0" className="text-black bg-white">
      Office Account
    </option>
  </select>
</div>

 <div className="flex flex-col gap-1">
   <input
     name="purchase_date"
     type="date"
     value={form.purchase_date}
     onChange={handleChange}
     className={`bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border ${errors.purchase_date ? 'border-red-500' : 'border-white/10'} text-white w-full`}
   />
   {errors.purchase_date && <span className="text-red-500 text-xs">{errors.purchase_date}</span>}
 </div>

 <input
   name="purpose"
   placeholder="Purpose"
   value={form.purpose}
   onChange={handleChange}
   className="bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white w-full"
 />

 <input
   name="vendor_info"
   placeholder="Vendor Info"
   value={form.vendor_info}
   onChange={handleChange}
   className="bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white w-full"
 />

 

 <input
   name="remark"
   placeholder="Remark"
   value={form.remark}
   onChange={handleChange}
   className="bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white w-full"
 />

 {/* FILE UPLOAD */}
 <div className="flex flex-col gap-2">
   <label className="font-medium text-white/60">Upload Bill (Compressed to WebP)</label>
   <input
     type="file"
     accept="image/*"
     onChange={handleFile}
     className="bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white w-full"
   />
 </div>

</div>

<button
 onClick={submitExpense}
 disabled={loading}
 className="
   mt-8 px-6 py-3
  
   bg-gradient-to-r from-[#110EFD] to-[#110EFD]
   hover:from-[#2DC6FD] hover:to-[#2DC6FD]
    text-white rounded-lg shadow
   hover:opacity-90 transition
 "
>
 {loading ? "Saving..." : "Add Expense"}
</button>


        </div>
      </div>
 
      <SuccessModal
        show={showSuccessModal}
        onClose={() => setShowSuccessModal(false)}
      />
    </div>
  );
}





// import { useEffect, useState } from "react";
// import {
//   getExpenseCategoriesApi,
//   addOfficeExpenseApi,
// } from "../../app/api";
// import { toast } from "react-toastify";
// import {
//   PlusCircle,
//   IndianRupee,
//   Tag,
//   ShieldCheck,
//   Calendar,
//   Activity,
//   User,
//   StickyNote,
//   UploadCloud,
//   CheckCircle2,
//   X,
//   CreditCard
// } from "lucide-react";
 
// /* SUCCESS MODAL (Premium Glass) */
// function SuccessModal({ show, message, onClose }) {
//   if (!show) return null;
 
//   return (
//     <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
//       <div className="absolute inset-0 bg-black/60 backdrop-blur-md" onClick={onClose} />
//       <div className="
//         relative w-full max-w-sm
//         bg-gradient-to-br from-[#1e174a] to-[#0f0c29]
//         rounded-[40px] p-10 text-center
//         border border-white/20 shadow-2xl animate-scaleIn
//       ">
//         <div className="flex justify-center mb-8">
//           <div className="w-24 h-24 rounded-[32px] bg-green-500/20 flex items-center justify-center shadow-inner">
//             <CheckCircle2 className="w-12 h-12 text-green-400" />
//           </div>
//         </div>
//         <h3 className="text-3xl font-black mb-3 text-white">Record Saved!</h3>
//         <p className="text-white/50 text-base mb-10 leading-relaxed font-medium">
//           The office expense has been successfully logged into the system.
//         </p>
//         <button
//           onClick={onClose}
//           className="
//             w-full py-4 rounded-2xl font-bold bg-white text-black
//             hover:bg-blue-300 transition shadow-xl
//           "
//         >
//           Excellent
//         </button>
//       </div>
//     </div>
//   );
// }
 
// export default function AddExpense() {
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
 
//   const [form, setForm] = useState({
//     amount: "",
//     expense_category_id: "",
//     is_hr_account: 1,
//     purchase_date: new Date().toISOString().split("T")[0],
//     purpose: "",
//     vendor_info: "",
//     remark: "",
//     bill: null,
//   });
 
//   const [errors, setErrors] = useState({});
 
//   const loadCategories = async () => {
//     const res = await getExpenseCategoriesApi();
//     if (res.success) setCategories(res.data || []);
//     else toast.error("Failed to load categories");
//   };
 
//   useEffect(() => {
//     loadCategories();
//   }, []);
 
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setForm({ ...form, [name]: value });
//     if (errors[name]) setErrors(prev => ({ ...prev, [name]: "" }));
//   };
 
//   const handleFile = (e) => {
//     const file = e.target.files[0];
//     if (file) setForm({ ...form, bill: file });
//   };
 
//   const submitExpense = async () => {
//     const newErrors = {};
//     if (!form.expense_category_id) newErrors.expense_category_id = "Required";
//     if (!form.amount) newErrors.amount = "Required";
//     if (!form.purchase_date) newErrors.purchase_date = "Required";
 
//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       return toast.error("Please provide all mandatory details");
//     }
 
//     const fd = new FormData();
//     Object.keys(form).forEach(key => fd.append(key, form[key]));
 
//     setLoading(true);
//     const res = await addOfficeExpenseApi(fd);
//     setLoading(false);
 
//     if (res.success) {
//       setShowSuccessModal(true);
//       setForm({
//         amount: "",
//         expense_category_id: "",
//         is_hr_account: 1,
//         purchase_date: new Date().toISOString().split("T")[0],
//         purpose: "",
//         vendor_info: "",
//         remark: "",
//         bill: null,
//       });
//     } else {
//       toast.error(res.message || "Failed to log expense");
//     }
//   };
 
//   return (
//     <div className="max-w-8xl mx-auto md:mt-20 mb-20 px-4">
//     <div className="
//       relative overflow-hidden
//       rounded-[40px] p-8 md:p-12
//       bg-gradient-to-br from-[#1e174a] to-[#0f0c29]/95
//       backdrop-blur-2xl text-white
//       border border-white/10
//       shadow-[0_40px_100px_-20px_rgba(0,0,0,0.7)]
//     ">
//         {/* Decorative Elements */}
//         <div className="absolute top-0 right-0 w-64 h-64 bg-indigo-600/10 blur-[100px] pointer-events-none" />
//         <div className="absolute bottom-0 left-0 w-64 h-64 bg-purple-600/10 blur-[100px] pointer-events-none" />
 
//         <div className="relative z-10">
//           <div className="flex items-center gap-4 mb-8">
//             <div className="p-3.5 rounded-2xl bg-gradient-to-br from-blue-500 to-indigo-600 shadow-lg shadow-blue-500/20">
//               <PlusCircle className="w-8 h-8 text-white" />
//             </div>
//             <div>
//               <h1 className="text-3xl font-black tracking-tight">Add Expense</h1>
//               <p className="text-white/50 text-sm font-medium">Record a new office expenditure into the ledger</p>
//             </div>
//           </div>
 
//           <div className="space-y-2">
//             {/* Primary Fields Grid */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-2">
//               {/* Amount */}
//               <div className="space-y-2">
//                 <label className="text-[11px] font-bold uppercase tracking-widest text-white/40 ml-1">Total Amount</label>
//                 <div className="relative group">
//                   <div className="absolute left-5 top-1/2 -translate-y-1/2 text-white/30 group-focus-within:text-blue-400 transition">
//                     <IndianRupee className="w-4 h-4" />
//                   </div>
//                   <input
//                     name="amount"
//                     type="number"
//                     value={form.amount}
//                     onChange={handleChange}
//                     placeholder="0.00"
//                     className={`w-full bg-white/5 border ${errors.amount ? 'border-red-500/50' : 'border-white/10'} rounded-[24px] px-14 py-4 text-base font-bold outline-none transition focus:border-blue-500/50 focus:bg-white/[0.08]`}
//                   />
//                 </div>
//               </div>
 
//               {/* Category */}
//               <div className="space-y-2">
//                 <label className="text-[11px] font-bold uppercase tracking-widest text-white/40 ml-1">Category</label>
//                 <div className="relative group">
//                   <div className="absolute left-5 top-1/2 -translate-y-1/2 text-white/30 group-focus-within:text-purple-400 transition">
//                     <Tag className="w-4 h-4" />
//                   </div>
//                   <select
//                     name="expense_category_id"
//                     value={form.expense_category_id}
//                     onChange={handleChange}
//                     className={`w-full bg-white/5 border ${errors.expense_category_id ? 'border-red-500/50' : 'border-white/10'} rounded-[24px] px-14 py-4 text-sm font-bold outline-none transition focus:border-purple-500/50 focus:bg-white/[0.08] appearance-none cursor-pointer`}
//                   >
//                     <option value="" className="bg-[#1e174a]">Select Category</option>
//                     {categories.map((c) => (
//                       <option key={c.id} value={c.id} className="bg-[#1e174a]">{c.name}</option>
//                     ))}
//                   </select>
//                 </div>
//               </div>
 
//               {/* Account Type */}
//               <div className="space-y-2">
//                 <label className="text-[11px] font-bold uppercase tracking-widest text-white/40 ml-1">Funding Account</label>
//                 <div className="relative group">
//                   <div className="absolute left-5 top-1/2 -translate-y-1/2 text-white/30 group-focus-within:text-cyan-400 transition">
//                     <ShieldCheck className="w-4 h-4" />
//                   </div>
//                   <select
//                     name="is_hr_account"
//                     value={form.is_hr_account}
//                     onChange={handleChange}
//                     className="w-full bg-white/5 border border-white/10 rounded-[24px] px-14 py-4 text-sm font-bold outline-none transition focus:border-cyan-500/50 focus:bg-white/[0.08] appearance-none cursor-pointer"
//                   >
//                     <option value="1" className="bg-[#1e174a]">HR Account</option>
//                     <option value="0" className="bg-[#1e174a]">Office General Account</option>
//                   </select>
//                 </div>
//               </div>
 
//               {/* Purchase Date */}
//               <div className="space-y-2">
//                 <label className="text-[11px] font-bold uppercase tracking-widest text-white/40 ml-1">Spending Date</label>
//                 <div className="relative group">
//                   <div className="absolute left-5 top-1/2 -translate-y-1/2 text-white/30 group-focus-within:text-pink-400 transition">
//                     <Calendar className="w-4 h-4" />
//                   </div>
//                   <input
//                     name="purchase_date"
//                     type="date"
//                     value={form.purchase_date}
//                     onChange={handleChange}
//                     className={`w-full bg-white/5 border ${errors.purchase_date ? 'border-red-500/50' : 'border-white/10'} rounded-[24px] px-14 py-4 text-sm font-bold outline-none transition focus:border-pink-500/50 focus:bg-white/[0.08]`}
//                   />
//                 </div>
//               </div>
//             </div>
 
//             {/* Purpose & Vendor */}
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
//               <div className="space-y-2">
//                 <label className="text-[11px] font-bold uppercase tracking-widest text-white/40 ml-1">Internal Purpose</label>
//                 <div className="relative group">
//                   <div className="absolute left-5 top-1/2 -translate-y-1/2 text-white/30 group-focus-within:text-emerald-400 transition">
//                     <Activity className="w-4 h-4" />
//                   </div>
//                   <input
//                     name="purpose"
//                     placeholder="What was this for?"
//                     value={form.purpose}
//                     onChange={handleChange}
//                     className="w-full bg-white/5 border border-white/10 rounded-[24px] px-14 py-4 text-sm font-bold outline-none transition focus:border-emerald-500/50 focus:bg-white/[0.08]"
//                   />
//                 </div>
//               </div>
 
//               <div className="space-y-2">
//                 <label className="text-[11px] font-bold uppercase tracking-widest text-white/40 ml-1">Vendor Details</label>
//                 <div className="relative group">
//                   <div className="absolute left-5 top-1/2 -translate-y-1/2 text-white/30 group-focus-within:text-amber-400 transition">
//                     <User className="w-4 h-4" />
//                   </div>
//                   <input
//                     name="vendor_info"
//                     placeholder="Company or Person name"
//                     value={form.vendor_info}
//                     onChange={handleChange}
//                     className="w-full bg-white/5 border border-white/10 rounded-[24px] px-14 py-4 text-sm font-bold outline-none transition focus:border-amber-500/50 focus:bg-white/[0.08]"
//                   />
//                 </div>
//               </div>
//             </div>
 
//             {/* Remarks */}
//             <div className="space-y-2">
//               <label className="text-[11px] font-bold uppercase tracking-widest text-white/40 ml-1">Additional Remarks</label>
//               <div className="relative group">
//                 <div className="absolute left-5 top-5 text-white/30 group-focus-within:text-white transition">
//                   <StickyNote className="w-4 h-4" />
//                 </div>
//                 <textarea
//                   name="remark"
//                   rows={3}
//                   placeholder="Any extra context for the accountant..."
//                   value={form.remark}
//                   onChange={handleChange}
//                   className="w-full bg-white/5 border border-white/10 rounded-[32px] px-14 py-4 text-sm font-medium outline-none transition focus:border-white/30 focus:bg-white/[0.08] resize-none"
//                 />
//               </div>
//             </div>
 
//             {/* File Upload */}
//             <div className="space-y-2">
//               <label className="text-[11px] font-bold uppercase tracking-widest text-white/40 ml-1">Proof of Purchase (Receipt/Bill)</label>
//               <label className="
//                 relative block w-full rounded-[32px] border-2 border-dashed border-white/10 bg-white/20 p-8 cursor-pointer
//                 hover:bg-white/10 hover:border-white/30 transition-all group/file
//               ">
//                 <input type="file" className="hidden" accept="image/*,.pdf" onChange={handleFile} />
//                 <div className="flex flex-col items-center gap-3">
//                   <div className="p-4 rounded-2xl bg-white/5 group-hover/file:scale-110 transition duration-300">
//                     <UploadCloud className="w-8 h-8 text-blue-400" />
//                   </div>
//                   <div className="text-center">
//                     <p className="text-sm font-black text-white">{form.bill ? form.bill.name : 'Click to Upload Invoice'}</p>
//                     <p className="text-[10px] uppercase font-bold text-white/20 tracking-widest mt-1">Maximum 5MB · PDF, JPG, or PNG</p>
//                   </div>
//                 </div>
//               </label>
//             </div>
 
//             {/* Submit Action */}
//             <div className="pt-6">
//               <button
//                 onClick={submitExpense}
//                 disabled={loading}
//                 className="
//                   w-full py-5 rounded-[28px] font-black text-xs uppercase tracking-[4px]
//                   bg-gradient-to-r from-blue-600 via-indigo-600 to-purple-700
//                   hover:scale-[1.02] active:scale-[0.98]
//                   transition-all duration-300 shadow-2xl shadow-indigo-900/50
//                   flex items-center justify-center gap-3
//                   disabled:opacity-50 disabled:cursor-not-allowed
//                 "
//               >
//                 {loading ? (
//                   <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin" />
//                 ) : (
//                   <>
//                     <CreditCard className="w-5 h-5" />
//                     Archive Expense
//                   </>
//                 )}
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>
 
//       <SuccessModal
//         show={showSuccessModal}
//         onClose={() => setShowSuccessModal(false)}
//       />
//     </div>
//   );
// }
 
// import { useEffect, useState } from "react";
// import {
//   getExpenseCategoriesApi,
//   addOfficeExpenseApi,
// } from "../../app/api";
 
// import { toast } from "react-toastify";
 
// // SUCCESS MODAL (Animated + Same Logic)
// function SuccessModal({ show, message, onClose }) {
//   if (!show) return null;
 
//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm z-50 animate-fadeIn">
 
//       <div className="bg-white p-8 rounded-2xl shadow-xl w-80 text-center border-b-4 border-green-500 animate-scaleIn">
 
//         {/* Success Tick */}
//         <div className="mx-auto bg-green-100 w-20 h-20 rounded-full flex items-center justify-center animate-pop">
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="w-10 h-10 text-green-600"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="3"
//           >
//             <path d="M5 13l4 4L19 7" />
//           </svg>
//         </div>
 
//         <h2 className="text-xl font-semibold text-gray-800 mt-4">
//           Success!
//         </h2>
 
//         <p className="text-gray-600 mt-1">{message}</p>
 
//         <button
//           onClick={onClose}
//           className="mt-5 px-5 py-2 bg-green-600 text-white rounded-xl shadow hover:bg-green-700 transition"
//         >
//           OK
//         </button>
 
//       </div>
//     </div>
//   );
// }
 
 
// export default function AddExpense() {
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);
 
//   const [showSuccessModal, setShowSuccessModal] = useState(false);
 
//   const [form, setForm] = useState({
//     amount: "",
//     expense_category_id: "",
//     is_hr_account: 1,
//     purchase_date: "",
//     purpose: "",
//     vendor_info: "",
//     remark: "",
//     bill: null,
//   });
 
//   const [errors, setErrors] = useState({});
 
//   const loadCategories = async () => {
//     const res = await getExpenseCategoriesApi();
//     if (res.success) setCategories(res.data);
//     else toast.error("Failed to load categories");
//   };
 
//   useEffect(() => {
//     loadCategories();
//   }, []);
 
//   const handleChange = (e) => {
//     const { name, value } = e.target;
 
//     setForm({
//       ...form,
//       [name]: value,
//     });
//   };
 
//   const handleFile = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
 
//     // Image compression logic
//     if (file.type.startsWith("image/")) {
//       const compressedFile = await compressImageToWebP(file);
//       setForm({ ...form, bill: compressedFile });
//     } else {
//       setForm({ ...form, bill: file });
//     }
//   };
 
//   const compressImageToWebP = (file) => {
//     return new Promise((resolve) => {
//       const reader = new FileReader();
//       reader.readAsDataURL(file);
//       reader.onload = (event) => {
//         const img = new Image();
//         img.src = event.target.result;
//         img.onload = () => {
//           const canvas = document.createElement("canvas");
//           const ctx = canvas.getContext("2d");
 
//           // Keep original dimensions but compress quality
//           canvas.width = img.width;
//           canvas.height = img.height;
//           ctx.drawImage(img, 0, 0);
 
//           canvas.toBlob(
//             (blob) => {
//               const compressedFile = new File([blob], file.name.replace(/\.[^/.]+$/, "") + ".webp", {
//                 type: "image/webp",
//                 lastModified: Date.now(),
//               });
//               resolve(compressedFile);
//             },
//             "image/webp",
//             0.7 // quality
//           );
//         };
//       };
//     });
//   };
 
//   const submitExpense = async () => {
//     const newErrors = {};
//     if (!form.expense_category_id) newErrors.expense_category_id = "Category is mandatory";
//     if (!form.amount) newErrors.amount = "Amount is mandatory";
//     if (!form.purchase_date) newErrors.purchase_date = "Purchase date is mandatory";
 
//     if (Object.keys(newErrors).length > 0) {
//       setErrors(newErrors);
//       return toast.error("Please fill all mandatory fields");
//     }
 
//     setErrors({});
 
//     const fd = new FormData();
//     Object.keys(form).forEach((key) => {
//       fd.append(key, form[key]);
//     });
 
//     setLoading(true);
//     const res = await addOfficeExpenseApi(fd);
//     setLoading(false);
 
//     if (res.success) {
//       toast.success("Expense added successfully");
 
//       // Show modal
//       setShowSuccessModal(true);
//       setTimeout(() => setShowSuccessModal(false), 2500);
 
//       setForm({
//         amount: "",
//         expense_category_id: "",
//         is_hr_account: 1,
//         purchase_date: "",
//         purpose: "",
//         vendor_info: "",
//         remark: "",
//         bill: null,
//       });
//     } else {
//       toast.error(res.message || "Failed to add expense");
//     }
//   };
 
//   return (
//     <>
   
//     {/* // <div className="w-full md:w-[1104px] min-h-screen bg-white p-4 md:p-10 "> */}
 
 
//     <div className="min-h-screen  px-2 py-4 sm:p-6 justify-center flex ml-0 md:mt-20 ">
//     <div
//      className="
//      bg-gradient-to-br
//      from-[#2d1c6a]
//      via-[#24155a]
//      to-[#12082f] backdrop-blur-md rounded-2xl shadow-lg
//      w-full max-w-4xl p-4 sm:p-6 justify-center
//     "
//   >
 
// {/* <div
//       className="
//       rounded-2xl
//       p-6
//       md:mt-20
//       bg-gradient-to-br
//       from-[#2d1c6a]
//       via-[#24155a]
//       to-[#12082f]
//       text-white
//       border border-white/10
//       shadow-2xl shadow-[#12082F]/60
//       relative
//     "
//     > */}
   
       
//       <div className="items-center mb-4">
 
//       {/* SUCCESS MODAL */}
//       <SuccessModal
//         show={showSuccessModal}
//         message="Expense added successfully!"
//         onClose={() => setShowSuccessModal(false)}
//       />
 
//       {/* <div className="
//         bg-gray-100
//          rounded-[5px]
//         p-6 md:p-10 shadow-md
//         border-b-[6px]  min-h-screen
//       "> */}
 
//         <h1 className="text-2xl md:text-2xl mt-4 font-semibold  mb-8 text-white">
//           Add Office Expense
//         </h1>
 
//         {/* FORM GRID */}
//          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
 
//           <div className="flex flex-col gap-1">
//             <input
//               name="amount"
//               placeholder="Amount"
//               value={form.amount}
//               onChange={handleChange}
//               className={`bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border ${errors.amount ? 'border-red-500' : 'border-white/10'} text-white w-full`}
//             />
//             {errors.amount && <span className="text-red-500 text-xs">{errors.amount}</span>}
//           </div>
 
//           <div className="flex flex-col gap-1">
//             <select
//               name="expense_category_id"
//               value={form.expense_category_id}
//               onChange={handleChange}
//               className={`bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border ${errors.expense_category_id ? 'border-red-500' : 'border-white/10'} text-white w-full`}
//             >
//               <option value="" className="bg-[#24155a] text-white">Select Category</option>
//               {categories.map((c) => (
//                 <option key={c.id} value={c.id} className="bg-[#24155a] text-white">
//                   {c.name}
//                 </option>
//               ))}
//             </select>
//             {errors.expense_category_id && <span className="text-red-500 text-xs">{errors.expense_category_id}</span>}
//           </div>
 
//           <div className="flex flex-col gap-1">
//             <select
//               name="is_hr_account"
//               value={form.is_hr_account}
//               onChange={handleChange}
//               className="bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white w-full"
//             >
//               <option value="1">HR Account</option>
//               <option value="0">Office Account</option>
//             </select>
//           </div>
 
//           <div className="flex flex-col gap-1">
//             <input
//               name="purchase_date"
//               type="date"
//               value={form.purchase_date}
//               onChange={handleChange}
//               className={`bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border ${errors.purchase_date ? 'border-red-500' : 'border-white/10'} text-white w-full`}
//             />
//             {errors.purchase_date && <span className="text-red-500 text-xs">{errors.purchase_date}</span>}
//           </div>
 
//           <input
//             name="purpose"
//             placeholder="Purpose"
//             value={form.purpose}
//             onChange={handleChange}
//             className="bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white w-full"
//           />
 
//           <input
//             name="vendor_info"
//             placeholder="Vendor Info"
//             value={form.vendor_info}
//             onChange={handleChange}
//             className="bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white w-full"
//           />
 
//           <input
//             name="purpose"
//             placeholder="Purpose"
//             value={form.purpose}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white "
//           />
 
//           <input
//             name="vendor_info"
//             placeholder="Vendor Info"
//             value={form.vendor_info}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white "
//           />
 
//           <input
//             name="remark"
//             placeholder="Remark"
//             value={form.remark}
//             onChange={handleChange}
//             className="bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white w-full"
//           />
 
//           {/* FILE UPLOAD */}
//           <div className="flex flex-col gap-2">
//             <label className="font-medium text-white/60">Upload Bill (Compressed to WebP)</label>
//             <input
//               type="file"
//               accept="image/*"
//               onChange={handleFile}
//               className="bg-white/10 rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white w-full"
//             />
//           </div>
 
//         </div>
 
//         <button
//           onClick={submitExpense}
//           disabled={loading}
//           className="
//             mt-8 px-6 py-3
           
//             bg-gradient-to-r from-[#110EFD] to-[#110EFD]
//             hover:from-[#2DC6FD] hover:to-[#2DC6FD]
//              text-white rounded-lg shadow
//             hover:opacity-90 transition
//           "
//         >
//           {loading ? "Saving..." : "Add Expense"}
//         </button>
 
//       </div>
//     </div>
//     </div>
//     </>
//   );
// }
 
 
 







// import { useEffect, useState } from "react";
// import {
//   getExpenseCategoriesApi,
//   addOfficeExpenseApi,
// } from "../../app/api";

// import { toast } from "react-toastify";
// import imageCompression from "browser-image-compression"; // ✅ NEW
// // SUCCESS MODAL (Animated + Same Logic)
// function SuccessModal({ show, message, onClose }) {
//   if (!show) return null;

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm z-50 animate-fadeIn">

//       <div className="bg-white p-8 rounded-2xl shadow-xl w-80 text-center border-b-4 border-green-500 animate-scaleIn">

//         {/* Success Tick */}
//         <div className="mx-auto bg-green-100 w-20 h-20 rounded-full flex items-center justify-center animate-pop">
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="w-10 h-10 text-green-600"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="3"
//           >
//             <path d="M5 13l4 4L19 7" />
//           </svg>
//         </div>

//         <h2 className="text-xl font-semibold text-gray-800 mt-4">
//           Success!
//         </h2>

//         <p className="text-gray-600 mt-1">{message}</p>

//         <button
//           onClick={onClose}
//           className="mt-5 px-5 py-2 bg-green-600 text-white rounded-xl shadow hover:bg-green-700 transition"
//         >
//           OK
//         </button>

//       </div>
//     </div>
//   );
// }


// export default function AddExpense() {
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [showSuccessModal, setShowSuccessModal] = useState(false);

//   const [form, setForm] = useState({
//     amount: "",
//     expense_category_id: "",
//     is_hr_account: 1,
//     purchase_date: "",
//     purpose: "",
//     vendor_info: "",
//     remark: "",
//     bill: null,
//   });

//   const loadCategories = async () => {
//     const res = await getExpenseCategoriesApi();
//     if (res.success) setCategories(res.data);
//     else toast.error("Failed to load categories");
//   };

//   useEffect(() => {
//     loadCategories();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm({
//       ...form,
//       [name]: value,
//     });
//   };

//   // const handleFile = (e) => {
//   //   setForm({ ...form, bill: e.target.files[0] });
//   // };

//   const handleFile = async (e) => {
//     const file = e.target.files[0];
//     if (!file) return;
  
//     // ❌ File size check (2MB)
//     if (file.size > 2 * 1024 * 1024) {
//       toast.error("File too large (Max 2MB)");
//       return;
//     }
  
//     try {
//       // ✅ Compress image
//       const compressedFile = await imageCompression(file, {
//         maxSizeMB: 1,
//         maxWidthOrHeight: 1024,
//         useWebWorker: true,
//       });
  
//       setForm((prev) => ({
//         ...prev,
//         bill: compressedFile,
//       }));
//     } catch (err) {
//       toast.error("Image compression failed");
//     }
//   };












//   const submitExpense = async () => {
//     if (!form.expense_category_id) {
//       return toast.error("Select category");
//     }
//     if (!form.amount) {
//       return toast.error("Enter amount");
//     }
//     if (!form.purchase_date) {
//       return toast.error("Select purchase date");
//     }

//     const fd = new FormData();
//     // Object.keys(form).forEach((key) => {
//     //   fd.append(key, form[key]);
//     // });


//     Object.entries(form).forEach(([key, value]) => {
//       if (value !== null && value !== "") {
//         fd.append(key, value);
//       }
//     });

//     setLoading(true);
//     const res = await addOfficeExpenseApi(fd);
//     setLoading(false);

//     if (res.success) {
//       toast.success("Expense added successfully");

//       // Show modal
//       setShowSuccessModal(true);
//       setTimeout(() => setShowSuccessModal(false), 2500);

//       setForm({
//         amount: "",
//         expense_category_id: "",
//         is_hr_account: 1,
//         purchase_date: "",
//         purpose: "",
//         vendor_info: "",
//         remark: "",
//         bill: null,
//       });
//     } else {
//       toast.error(res.message || "Failed to add expense");
//     }
//   };

//   return (
//     <>
   
//     {/* // <div className="w-full md:w-[1104px] min-h-screen bg-white p-4 md:p-10 "> */}


//     <div className="min-h-screen  px-2 py-4 sm:p-6 justify-center flex ml-0 md:mt-20 ">
//     <div
//      className="
//      bg-gradient-to-br
//      from-[#2d1c6a]
//      via-[#24155a]
//      to-[#12082f] backdrop-blur-md rounded-2xl shadow-lg
//      w-[360px] md:w-full p-4 sm:p-6 justify-center
//     "
//   >

// {/* <div
//       className="
//       rounded-2xl
//       p-6
//       md:mt-20
//       bg-gradient-to-br
//       from-[#2d1c6a]
//       via-[#24155a]
//       to-[#12082f]
//       text-white
//       border border-white/10
//       shadow-2xl shadow-[#12082F]/60
//       relative
//     "
//     > */}
   
       
//       <div className="items-center mb-4">

//       {/* SUCCESS MODAL */}
//       <SuccessModal
//         show={showSuccessModal}
//         message="Expense added successfully!"
//         onClose={() => setShowSuccessModal(false)}
//       />

//       {/* <div className="
//         bg-gray-100
//          rounded-[5px]
//         p-6 md:p-10 shadow-md
//         border-b-[6px]  min-h-screen
//       "> */}

//         <h1 className="text-2xl md:text-2xl mt-4 font-semibold  mb-8 text-white">
//           Add Office Expense
//         </h1>

//         {/* FORM GRID */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

//           <input
//             name="amount"
//             placeholder="Amount"
//             value={form.amount}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white  "
//           />

//           <select
//             name="expense_category_id"
//             value={form.expense_category_id}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3te py-2 text-sm shadow-lg border border-white/10 text-white  "
//           >
//             <option value=" bg-[#24155a] text-white">Select Category</option>
//             {categories.map((c) => (
//               <option key={c.id} value={c.id} className="bg-[#24155a] text-white">
//                 {c.name}
//               </option>
//             ))}
//           </select>

//           <select
//             name="is_hr_account"
//             value={form.is_hr_account}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white  "
//           >
//              <option value="1">HR Account</option>
//             <option value="0">Office Account</option>
//             {/* <option value="1">HR Account</option> */}
//           </select>

//           <input
//             name="purchase_date"
//             type="date"
//             value={form.purchase_date}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white "
//           />

//           <input
//             name="purpose"
//             placeholder="Purpose"
//             value={form.purpose}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white "
//           />

//           <input
//             name="vendor_info"
//             placeholder="Vendor Info"
//             value={form.vendor_info}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white "
//           />

//           <input
//             name="remark"
//             placeholder="Remark"
//             value={form.remark}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white"
//           />

//           {/* FILE UPLOAD */}
//           <div className="flex flex-col gap-2">
//             <label className="font-medium text-white/60">Upload Bill</label>
//             <input
//               type="file"
//               onChange={handleFile}
//               className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white "
//             />
//           </div>

//         </div>

//         <button
//           onClick={submitExpense}
//           disabled={loading}
//           className="
//             mt-8 px-6 py-3 
            
//             bg-gradient-to-r from-[#110EFD] to-[#110EFD] 
//             hover:from-[#2DC6FD] hover:to-[#2DC6FD]
//              text-white rounded-lg shadow
//             hover:opacity-90 transition
//           "
//         >
//           {loading ? "Saving..." : "Add Expense"}
//         </button>

//       </div>
//     </div>
//     </div>
//     </>
//   );
// }







// // import { useEffect, useState } from "react";
// // import {
// //   getExpenseCategoriesApi,
// //   addOfficeExpenseApi
// // } from "../Api/Api";
// // import { toast } from "react-toastify";

// import { useEffect, useState } from "react";
// import {
//   getExpenseCategoriesApi,
//   addOfficeExpenseApi,
// } from "../../app/api";

// import { toast } from "react-toastify";

// // SUCCESS MODAL (Animated + Same Logic)
// function SuccessModal({ show, message, onClose }) {
//   if (!show) return null;

//   return (
//     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-30 backdrop-blur-sm z-50 animate-fadeIn">

//       <div className="bg-white p-8 rounded-2xl shadow-xl w-80 text-center border-b-4 border-green-500 animate-scaleIn">

//         {/* Success Tick */}
//         <div className="mx-auto bg-green-100 w-20 h-20 rounded-full flex items-center justify-center animate-pop">
//           <svg
//             xmlns="http://www.w3.org/2000/svg"
//             className="w-10 h-10 text-green-600"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="3"
//           >
//             <path d="M5 13l4 4L19 7" />
//           </svg>
//         </div>

//         <h2 className="text-xl font-semibold text-gray-800 mt-4">
//           Success!
//         </h2>

//         <p className="text-gray-600 mt-1">{message}</p>

//         <button
//           onClick={onClose}
//           className="mt-5 px-5 py-2 bg-green-600 text-white rounded-xl shadow hover:bg-green-700 transition"
//         >
//           OK
//         </button>

//       </div>
//     </div>
//   );
// }


// export default function AddExpense() {
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [showSuccessModal, setShowSuccessModal] = useState(false);

//   const [form, setForm] = useState({
//     amount: "",
//     expense_category_id: "",
//     is_hr_account: 1,
//     purchase_date: "",
//     purpose: "",
//     vendor_info: "",
//     remark: "",
//     bill: null,
//   });

//   const loadCategories = async () => {
//     const res = await getExpenseCategoriesApi();
//     if (res.success) setCategories(res.data);
//     else toast.error("Failed to load categories");
//   };

//   useEffect(() => {
//     loadCategories();
//   }, []);

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     setForm({
//       ...form,
//       [name]: value,
//     });
//   };

//   const handleFile = (e) => {
//     setForm({ ...form, bill: e.target.files[0] });
//   };

//   const submitExpense = async () => {
//     if (!form.expense_category_id) {
//       return toast.error("Select category");
//     }
//     if (!form.amount) {
//       return toast.error("Enter amount");
//     }
//     if (!form.purchase_date) {
//       return toast.error("Select purchase date");
//     }

//     const fd = new FormData();
//     Object.keys(form).forEach((key) => {
//       fd.append(key, form[key]);
//     });

//     setLoading(true);
//     const res = await addOfficeExpenseApi(fd);
//     setLoading(false);

//     if (res.success) {
//       toast.success("Expense added successfully");

//       // Show modal
//       setShowSuccessModal(true);
//       setTimeout(() => setShowSuccessModal(false), 2500);

//       setForm({
//         amount: "",
//         expense_category_id: "",
//         is_hr_account: 1,
//         purchase_date: "",
//         purpose: "",
//         vendor_info: "",
//         remark: "",
//         bill: null,
//       });
//     } else {
//       toast.error(res.message || "Failed to add expense");
//     }
//   };

//   return (
//     <>
   
//     {/* // <div className="w-full md:w-[1104px] min-h-screen bg-white p-4 md:p-10 "> */}


//     <div className="min-h-screen  px-2 py-4 sm:p-6 justify-center flex ml-0 md:mt-20 ">
//     <div
//      className="
//      bg-gradient-to-br
//      from-[#2d1c6a]
//      via-[#24155a]
//      to-[#12082f] backdrop-blur-md rounded-2xl shadow-lg
//      w-[360px] md:w-full p-4 sm:p-6 justify-center
//     "
//   >

// {/* <div
//       className="
//       rounded-2xl
//       p-6
//       md:mt-20
//       bg-gradient-to-br
//       from-[#2d1c6a]
//       via-[#24155a]
//       to-[#12082f]
//       text-white
//       border border-white/10
//       shadow-2xl shadow-[#12082F]/60
//       relative
//     "
//     > */}
   
       
//       <div className="items-center mb-4">

//       {/* SUCCESS MODAL */}
//       <SuccessModal
//         show={showSuccessModal}
//         message="Expense added successfully!"
//         onClose={() => setShowSuccessModal(false)}
//       />

//       {/* <div className="
//         bg-gray-100
//          rounded-[5px]
//         p-6 md:p-10 shadow-md
//         border-b-[6px]  min-h-screen
//       "> */}

//         <h1 className="text-2xl md:text-2xl mt-4 font-semibold  mb-8 text-white">
//           Add Office Expense
//         </h1>

//         {/* FORM GRID */}
//         <div className="grid grid-cols-1 md:grid-cols-3 gap-6">

//           <input
//             name="amount"
//             placeholder="Amount"
//             value={form.amount}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white  "
//           />

//           <select
//             name="expense_category_id"
//             value={form.expense_category_id}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3te py-2 text-sm shadow-lg border border-white/10 text-white  "
//           >
//             <option value=" bg-[#24155a] text-white">Select Category</option>
//             {categories.map((c) => (
//               <option key={c.id} value={c.id} className="bg-[#24155a] text-white">
//                 {c.name}
//               </option>
//             ))}
//           </select>

//           <select
//             name="is_hr_account"
//             value={form.is_hr_account}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white  "
//           >
//              <option value="1">HR Account</option>
//             <option value="0">Office Account</option>
//             {/* <option value="1">HR Account</option> */}
//           </select>

//           <input
//             name="purchase_date"
//             type="date"
//             value={form.purchase_date}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white "
//           />

//           <input
//             name="purpose"
//             placeholder="Purpose"
//             value={form.purpose}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white "
//           />

//           <input
//             name="vendor_info"
//             placeholder="Vendor Info"
//             value={form.vendor_info}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white "
//           />

//           <input
//             name="remark"
//             placeholder="Remark"
//             value={form.remark}
//             onChange={handleChange}
//             className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white"
//           />

//           {/* FILE UPLOAD */}
//           <div className="flex flex-col gap-2">
//             <label className="font-medium text-white/60">Upload Bill</label>
//             <input
//               type="file"
//               onChange={handleFile}
//               className="bg-white/10  rounded-lg px-3 py-2 text-sm shadow-lg border border-white/10 text-white "
//             />
//           </div>

//         </div>

//         <button
//           onClick={submitExpense}
//           disabled={loading}
//           className="
//             mt-8 px-6 py-3 
            
//             bg-gradient-to-r from-[#110EFD] to-[#110EFD] 
//             hover:from-[#2DC6FD] hover:to-[#2DC6FD]
//              text-white rounded-lg shadow
//             hover:opacity-90 transition
//           "
//         >
//           {loading ? "Saving..." : "Add Expense"}
//         </button>

//       </div>
//     </div>
//     </div>
//     </>
//   );
// }









// import { useEffect, useState } from "react";
// import {
//   getExpenseCategoriesApi,
//   addOfficeExpenseApi,
// } from "../../app/api";

// export default function AddExpense() {
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [showSuccess, setShowSuccess] = useState(false);

//   const [form, setForm] = useState({
//     amount: "",
//     expense_category_id: "",
//     is_hr_account: 1,
//     purchase_date: "",
//     purpose: "",
//     vendor_info: "",
//     remark: "",
//     bill: null,
//   });

//   useEffect(() => {
//     getExpenseCategoriesApi().then((res) => {
//       if (res.success) setCategories(res.data || []);
//     });
//   }, []);

//   const handleChange = (e) => {
//     setForm({ ...form, [e.target.name]: e.target.value });
//   };

//   const handleFile = (e) => {
//     setForm({ ...form, bill: e.target.files[0] });
//   };

//   const submitExpense = async () => {
//     if (!form.expense_category_id || !form.amount || !form.purchase_date) {
//       return alert("Fill required fields");
//     }

//     const fd = new FormData();
//     Object.keys(form).forEach((k) => fd.append(k, form[k]));

//     setLoading(true);
//     const res = await addOfficeExpenseApi(fd);
//     setLoading(false);

//     if (res.success) {
//       setShowSuccess(true);
//       setTimeout(() => setShowSuccess(false), 2000);

//       setForm({
//         amount: "",
//         expense_category_id: "",
//         is_hr_account: 1,
//         purchase_date: "",
//         purpose: "",
//         vendor_info: "",
//         remark: "",
//         bill: null,
//       });
//     } else {
//       alert(res.message || "Failed");
//     }
//   };

//   return (
//     <div
//       className="
//       rounded-2xl
//       p-6
//       mt-20
//       bg-gradient-to-br
//       from-[#2d1c6a]
//       via-[#24155a]
//       to-[#12082f]
//       text-white
//       border border-white/10
//       shadow-2xl shadow-[#12082F]/60
//       relative
//     "
//     >
//       {/* glow */}
//       <div className="absolute -top-10 -right-10 w-60 h-60 bg-purple-500/20 blur-3xl rounded-full" />
//       <div className="absolute bottom-0 -left-10 w-60 h-60 bg-fuchsia-500/20 blur-3xl rounded-full" />

//       <h3 className="font-bold  text-2xl mb-6 relative z-10">
//         Add Office Expense
//       </h3>

//       <div className="grid grid-cols-1 md:grid-cols-3 gap-4 relative z-10">
//         <Input label="Amount" name="amount" value={form.amount} onChange={handleChange} />

//         <Select
//           label="Category"
//           name="expense_category_id"
//           value={form.expense_category_id}
//           onChange={handleChange}
//           options={categories.map((c) => ({
//             value: c.id,
//             label: c.name,
//           }))}
//         />

//         <Select
//           label="Account"
//           name="is_hr_account"
//           value={form.is_hr_account}
//           onChange={handleChange}
//           options={[
//             { value: 1, label: "HR Account" },
//             { value: 0, label: "Office Account" },
//           ]}
//         />

//         <Input
//           label="Purchase Date"
//           type="date"
//           name="purchase_date"
//           value={form.purchase_date}
//           onChange={handleChange}
//         />

//         <Input label="Purpose" name="purpose" value={form.purpose} onChange={handleChange} />
//         <Input label="Vendor" name="vendor_info" value={form.vendor_info} onChange={handleChange} />

//         <Input
//           label="Remark"
//           name="remark"
//           value={form.remark}
//           onChange={handleChange}
//           className="md:col-span-2"
//         />

//         <div className="flex flex-col gap-1">
//           <label className="text-white/70 text-xs">Bill</label>
//           <input
//             type="file"
//             onChange={handleFile}
//             className="bg-white/10 border border-white/20 rounded-lg px-3 py-2 text-sm"
//           />
//         </div>
//       </div>

//       {/* <button
//         onClick={submitExpense}
//         disabled={loading}
//         className="
//           mt-6 px-6 py-2 rounded-lg
//           bg-purple-600 hover:bg-purple-500
//           transition shadow
//         "
//       >
//         {loading ? "Saving..." : "Add Expense"}
//       </button> */}


// <button
//           onClick={submitExpense}
//           disabled={loading}
//           className="
//             mt-8 px-6 py-3 
            
//             bg-gradient-to-r from-[#110EFD] to-[#110EFD] 
//             hover:from-[#2DC6FD] hover:to-[#2DC6FD]
//              text-white rounded-sm shadow
//             hover:opacity-90 transition
//           "
//         >
//           {loading ? "Saving..." : "Add Expense"}
//         </button>

//       {/* SUCCESS */}
//       {/* {showSuccess && (
//         <div className="absolute inset-0 bg-black/50 flex items-center justify-center z-20">
//           <div className="bg-[#1c1045] border border-green-400/30 rounded-xl p-6 text-center">
//             <div className="text-green-400 text-xl mb-2">✔</div>
//             <p>Expense added successfully</p>
//           </div>
//         </div>
//       )} */}

// {showSuccess && (
//   <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
//     <div className="bg-[#1c1045] border border-green-400/30 rounded-xl p-6 text-center shadow-xl">
//       <div className="text-green-400 text-xl mb-2">✔</div>
//       <p>Expense added successfully</p>
//     </div>
//   </div>
// )}

//     </div>
//   );
// }

// /* ---------------- UI helpers ---------------- */

// function Input({ label, className = "", ...props }) {
//   return (
//     <div className={`flex flex-col gap-1 ${className}`}>
//       <label className="text-white/70 text-xs">{label}</label>
//       <input
//         {...props}
//         className="
//           bg-white/10 border border-white/20
//           rounded-lg px-3 py-2 text-sm
//           focus:outline-none focus:ring-2 focus:ring-purple-500/40
//         "
//       />
//     </div>
//   );
// }

// function Select({ label, options, className = "", ...props }) {
//   return (
//     <div className={`flex flex-col gap-1 ${className}`}>
//       <label className="text-white/70 text-xs">{label}</label>
//       <select
//         {...props}
//         className="
//           bg-white/10 border border-white/20
//           rounded-lg px-3 py-2 text-sm
//           focus:outline-none focus:ring-2 focus:ring-purple-500/40
//         "
//       >
//         <option value="">Select</option>
//         {options.map((o, i) => (
//           <option key={i} value={o.value} className="text-black">
//             {o.label}
//           </option>
//         ))}
//       </select>
//     </div>
//   );
// }
